<template>
  <el-dialog
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :title="$t('customCluster.addInstanceDialog.title')"
    :visible.sync="dialogVisible"
    :z-index="1000"
    width="900px"
  >
    <div class="dialog-div">
      <div class="base-text-align__right">
        <el-button type="text" @click="editInstances">{{
            $t('customCluster.addInstanceDialog.editClusterInfo')
          }}
        </el-button>
      </div>
      <div class="detailInfo_box">
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.currentInstanceNum') }}</span>
              <span>{{ info.instanceNum || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.region') }}</span>
              <span>{{ filterRegionList(info.region) || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.zone') }}</span>
              <span>{{ zoneName }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.securityGroup') }}</span>
              <span v-for="item in info.securityGroupIds" :key="item">
                <span>
                  {{ item }}
                </span>
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.imageId') }}</span>
              <span>{{ info.imageId || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.instanceType') }}</span>
              <span>{{ info.instanceType || '-' }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.diskType') }}</span>
              <span>{{ filterDiskType(info.diskType) || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.diskSize') }}</span>
              <span>{{ info.diskSize || '-' }} GiB</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.chargeType') }}</span>
              <span>{{
                  info.instanceChargeType === 'PREPAID' ? $t('customCluster.addInstanceDialog.prepaid') : $t('customCluster.addInstanceDialog.postpaid')
                }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.relatedNetwork') }}</span>
              <span>{{
                  !info.vpcName || !info.vpcCidr ? $t('customCluster.addInstanceDialog.resourceNotExist') : `(${info.vpcName} | ${info.vpcCidr})`
                }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.relatedSubnet') }}</span>
              <span>{{
                  !info.subnetName || !info.subnetCidr ? $t('customCluster.addInstanceDialog.resourceNotExist') : `(${info.subnetName} | ${info.subnetCidr})`
                }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="infoTitle">{{ $t('customCluster.addInstanceDialog.hyperThreading') }}</span>
              <span>{{
                  info.hyperTreading ? $t('customCluster.addInstanceDialog.on') : $t('customCluster.addInstanceDialog.off')
                }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="base-margin__bottom-20">
        <span class="base-margin__right-20">{{ $t('customCluster.addInstanceDialog.addType') }}</span>
        <el-radio-group v-model="radio" @input="checkRadio">
          <el-radio :label="1">{{ $t('customCluster.addInstanceDialog.complete') }}</el-radio>
          <el-radio :label="2">{{ $t('customCluster.addInstanceDialog.increment') }}</el-radio>
        </el-radio-group>
      </div>
      <div v-if="radio === 2" class="base-margin__bottom-20 base-flex">
        <span class="base-margin__right-20 start-ip">{{ $t('customCluster.addInstanceDialog.startIp') }}</span>
        <div class="start-ip__div">
          <div class="ip-part">
            <el-input v-model="startIp1" type="number"></el-input>
            <el-input v-model="startIp2" type="number"></el-input>
            <el-input v-model="startIp3" type="number"></el-input>
            <el-input v-model="startIp4" type="number"></el-input>
          </div>
        </div>
      </div>
      <div class="base-flex">
        <div class="base-margin__bottom-20 start-ip__div">
          <span class="base-margin__right-20 numberCls">{{ $t('customCluster.addInstanceDialog.quantity') }}</span>
          <el-input v-model="number" :placeholder="$t('customCluster.addInstanceDialog.pleaseEnter')"
                    class="base-margin__right-10"
                    type="number">
            <el-button slot="prepend" icon="el-icon-minus" @click="number > 1 && number--"></el-button>
            <el-button slot="append" icon="el-icon-plus" @click="number++"></el-button>
          </el-input>
        </div>
        <div>
          <el-button class="canCreateIP" type="primary" @click="previewIp">
            {{ $t('customCluster.addInstanceDialog.previewIp') }}
          </el-button>
          <!--预览ip-->
          <el-dialog
            :close-on-click-modal="false"
            :title="`${$t('customCluster.addInstanceDialog.previewIp')} ( ${previewList.length} )`"
            :visible.sync="previewDialogVisible"
            :z-index="1001"
            append-to-body
            width="500px"
          >
            <div class="previewDialog_main--div">
              <el-table
                ref="previewListTable"
                :data="previewList"
                :row-class-name="tableRowClassName"
                style="width: 100%"
              >
                <el-table-column :label="$t('customCluster.addInstanceDialog.hostname')" prop="hostname"
                                 width="180"></el-table-column>
                <el-table-column :label="$t('customCluster.addInstanceDialog.ip')" prop="ip"
                                 width="180"></el-table-column>
              </el-table>
            </div>
          </el-dialog>
          <el-dialog
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :title="$t('customCluster.addInstanceDialog.editClusterInfo')"
            :visible.sync="editInstancesVisible"
            :z-index="1001"
            append-to-body
            width="900px"
          >
            <div>
              <createCluster ref="createCluster" :closeDialog="closeDialog"></createCluster>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editInstancesVisible = false">{{
                  $t('customCluster.addInstanceDialog.cancel')
                }}</el-button>
              <el-button :loading="createLoading" type="primary"
                         @click="modifySubclusterConfig">{{ $t('customCluster.addInstanceDialog.confirm') }}</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
      <div class="base-flex">
        <div class="numberCls base-margin__right-20"></div>
        <div class="base-margin__bottom-20 hintCls">{{ $t('customCluster.addInstanceDialog.resourceHint') }}</div>
      </div>
      <div class="base-margin__bottom-20">
        <span class="base-margin__right-20">{{ $t('customCluster.addInstanceDialog.passwordType') }}</span>
        <el-radio-group v-model="passwordRadio" @input="checkPasswordRadio">
          <el-radio :disabled="info.imageType === 'PUBLIC_IMAGE'" :label="true">
            {{ $t('customCluster.addInstanceDialog.keepImageSetting') }}
          </el-radio>
          <el-radio :label="false">{{ $t('customCluster.addInstanceDialog.customPassword') }}</el-radio>
        </el-radio-group>
      </div>
      <div v-if="!isKeepImage">
        <div class="base-margin__bottom-20">
          <span class="base-margin__right-32" style="margin-right: 46px">
            {{ $t('customCluster.addInstanceDialog.password') }}
            <el-popover placement="top-start" trigger="hover" width="290">
              <div class="tips">
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule1') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule2') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule3') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule4') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule5') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule6') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule7') }}</p>
                <p class="base-margin__left-20" v-text="'()`~!@#$%^&*-+=_|{}[]:;\'<>,.?/'"></p>
              </div>
              <el-icon slot="reference" class="el-icon-question">{{
                  $t('customCluster.addInstanceDialog.hoverActivate')
                }}</el-icon>
            </el-popover>
          </span>
          <el-input
            v-model="password"
            :placeholder="$t('customCluster.addInstanceDialog.pleaseEnterPassword')"
            class="base-width__240"
            show-password
            type="password"
          ></el-input>
        </div>
        <div class="base-margin__bottom-20">
          <span class="base-margin__right-32"> {{ $t('customCluster.addInstanceDialog.confirmPassword') }} </span>
          <el-input
            v-model="nextPassword"
            :placeholder="$t('customCluster.addInstanceDialog.pleaseConfirmPassword')"
            class="base-width__240"
            show-password
            type="password"
          ></el-input>
        </div>
      </div>
    </div>
    <template #footer>
      <!--<div class="base-flex__between">-->
      <!--  <div>-->
      <!--    <span v-if="info.instanceChargeType !== 'PREPAID'">-->
      <!--      &lt;!&ndash;<span class="base-margin__right-10">{{ $t('header.dialog.expireTime') }}：</span>&ndash;&gt;-->
      <!--      <el-date-picker-->
      <!--        v-model="terminateActionTime"-->
      <!--        type="datetime"-->
      <!--        :placeholder="$t('multiCloudCluster.instanceDetails.detailsInfo.expireTime')">-->
      <!--      </el-date-picker>-->
      <!--    </span>-->
      <!--  </div>-->
        <div>
          <div v-if="!projectPriceBlacklist.includes(projectId.toString())" class="base-display__inline-block">
            <span class="create-price__span"><span>{{ $t('customCluster.addInstanceDialog.unitPrice') }}：</span></span>
            <span v-if="!unitPriceLoading" class="base-color__orange">{{ unitPriceDiscount }}</span>
            <i v-else class="el-icon-loading base-color__orange"></i>
            <span class="base-margin__right-10">{{
                info.instanceChargeType === 'POSTPAID_BY_HOUR' ? $t('customCluster.addInstanceDialog.yuanPerHour') : $t('customCluster.addInstanceDialog.yuanPerMonth')
              }}</span>
            <span v-if="number > 1" class="unitPrice_cls">
          <span class="create-price__span"><span>{{ $t('customCluster.addInstanceDialog.total') }}：</span></span>
          <span>{{ ((unitPriceDiscount * 100 * number) / 100).toFixed(2) }}</span>
          <span class="base-margin__right-10">{{
              info.instanceChargeType === 'POSTPAID_BY_HOUR' ? $t('customCluster.addInstanceDialog.yuanPerHour') : $t('customCluster.addInstanceDialog.yuanPerMonth')
            }}</span>
        </span>
          </div>
          <!--<span>-->
          <!--    <span class="base-margin__right-10"> 可用配额: {{-->
          <!--        describeAccountQuotaInfo.RemainingQuota || '-'-->
          <!--      }} / {{ describeAccountQuotaInfo.TotalQuota || '-' }} </span>-->
          <!--</span>-->
          <el-button :loading="examineInfoLoading" @click="runInstances('examine')">
            {{ $t('customCluster.addInstanceDialog.validateParams') }}
          </el-button>
          <!--<el-button @click="editInstances">编辑</el-button>-->
          <el-button :disabled="subclusterDetailDisabled || unitPriceLoading" type="primary" @click="runInstances('create')"
          >{{ $t('customCluster.addInstanceDialog.createInstance') }}
          </el-button>
        </div>
      <!--</div>-->
    </template>
    <!--订单确认-->
    <orderConfirmation ref="orderConfirmation" @finishOrder="finishOrder" />
  </el-dialog>
</template>

<script>
import { getRequest, postRequest } from '@/common/libs/request';
import { Message } from 'element-ui';
import { filterDiskType, filterRegionList } from '@/common/utils/utils';
import { regionNameMap } from '@/common/constants';
import createCluster from '@/views/customCluster/components/createCluster';
import orderConfirmation from '@/components/orderConfirmation';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'addInstanceDialog',
  props: {
    subclusterId: {
      type: Number,
    },
    getSubclusterInstances: Function,
    showLoading: Function,
    getSubclusterList: Function,
    openPwDialog: Function,
  },
  components: {
    createCluster,
    orderConfirmation,
  },
  data() {
    return {
      startIp1: '',
      startIp2: '',
      startIp3: '',
      startIp4: '',
      number: 1,
      password: '',
      nextPassword: '',
      dialogVisible: false,
      info: {},
      radio: 1,
      passwordRadio: true,
      isKeepImage: true,
      examineInfoLoading: false,
      subclusterDetailDisabled: false,
      previewDialogVisible: false,
      previewList: [],
      // 账号配额信息
      // describeAccountQuotaInfo: {},
      unitPriceDiscount: 0,
      unitPrice: 0,
      unitPriceLoading: false,
      filterRegionList,
      regionNameMap,
      filterDiskType,
      editInstancesVisible: false,
      createLoading: false,
      projectPriceBlacklist: sessionStorage.getItem('projectPriceBlacklist').split(',') || [], // 项目价格黑名单
      projectId: JSON.parse(sessionStorage.getItem('currentProject')).id || 0, // 当前项目ID
      terminateActionTime: 0, // 过期时间
    };
  },
  computed: {
    startIp() {
      return `${this.startIp1}.${this.startIp2}.${this.startIp3}.${this.startIp4}`;
    },
    zoneName() {
      if (this.info.zone && this.info.region) {
        const zoneList = this.info.zone.split('-');
        return `${this.regionNameMap.get(this.info.region)}${zoneList[zoneList.length - 1]}${this.$t('customCluster.addInstanceDialog.zoneSuffix')}`;
      }
      return '-';
    },
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getSubclusterDetail();
        this.terminateActionTime = '';
        this.password = '';
        this.nextPassword = '';
        this.number = 1;
        this.startIp1 = '';
        this.startIp2 = '';
        this.startIp3 = '';
        this.startIp4 = '';
        this.radio = 1;
        this.unitPriceDiscount = 0;
        this.unitPrice = 0;
        // this.describeAccountQuotaInfo = {};
        this.passwordRadio = true;
        this.isKeepImage = true;
      }
    },
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
      }
    },
  },
  methods: {
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.editInstancesVisible = false;
      this.getSubclusterDetail();
    },

    /**
     * 确定编辑集群
     */
    modifySubclusterConfig() {
      this.createLoading = true;
      try {
        this.$refs.createCluster
          .clickAccomplish()
          .then(() => {
            this.createLoading = false;
            this.$refs.createCluster.closeForm();
          })
          .catch(() => {
            this.createLoading = false;
          });
      } catch (e) {
        this.createLoading = false;
      }
    },
    // 预览可创建ip
    previewIp() {
      postRequest('/api/eda/common/subcluster/getAvailableIPList', {
        subclusterId: Number(this.subclusterId),
      }).then((res) => {
        this.previewDialogVisible = true;
        this.previewList = res.relationList.map(item => ({ ...item, type: '' }));

        if (this.radio === 1) {
          // 补全模式逻辑
          this.previewList = this.previewList.map((item, index) => (index < this.number
            ? {
              ...item,
              type: 'success-row',
            }
            : item));
        } else if (this.radio === 2 && this.startIp) {
          const cleanStartIp = this.startIp.trim();
          const startIndex = this.previewList.findIndex(item => item.ip === cleanStartIp);

          if (startIndex >= 0) {
            const validNumber = Math.max(1, parseInt(this.number) || 1);
            const highlightCount = Math.min(validNumber, this.previewList.length - startIndex);

            this.previewList = this.previewList.map((item, index) => (index >= startIndex && index < startIndex + highlightCount ? { ...item, type: 'success-row' } : item));
          } else {
            Message({
              type: 'warning',
              message: this.$t('customCluster.addInstanceDialog.startIpNotFound', { ip: cleanStartIp }),
            });
            this.previewList = this.previewList.map((item, index) => (index < this.number
              ? {
                ...item,
                type: 'success-row',
              }
              : item));
          }
        }
      });
    },

    tableRowClassName({ row }) {
      if (row.type === 'success-row') {
        return 'tableSelectBac';
      }
      return '';
    },

    /**
     * 编辑实例
     * @type type
     */
    editInstances() {
      this.editInstancesVisible = true;
      this.$nextTick(() => {
        this.$refs.createCluster.editCluster(this.subclusterId, 'edit');
      });
    },

    /**
     * 新增实例
     * @type type
     * @param {string} type 1:创建 2：启动
     */
    runInstances(type) {
      const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (!ipRegex.test(this.startIp)) {
        return this.$message.warning(this.$t('customCluster.addInstanceDialog.invalidStartIp'));
      }

      // 判断密码是否符合规范
      if (this.password !== '' && !this.validPassword(this.password) && this.isKeepImage === false) {
        return false;
      }

      // 判断密码是否为空
      if (this.isKeepImage === false && this.password === '') {
        return Message.warning(this.$t('customCluster.addInstanceDialog.passwordRequired'));
      }

      const data = {
        subclusterId: Number(this.subclusterId),
        instanceCount: Number(this.number),
        startIp: this.startIp,
        password: this.password,
        keepImageLogin: this.isKeepImage,
        terminateActionTime: this.terminateActionTime,
      };

      if (type === 'create') {
        const list = [{
          instanceType: this.info.instanceType,
          nodePrice: this.unitPriceDiscount,
          nodeCount: this.number,
          totalPrice: (this.unitPriceDiscount * this.number).toFixed(2),
          priceUnit: this.info.instanceChargeType === 'POSTPAID_BY_HOUR' ? this.$t('customCluster.addInstanceDialog.yuanPerHour') : this.$t('customCluster.addInstanceDialog.yuanPerMonth'),
        }];
        this.$refs.orderConfirmation.showOrderConfirmation({ list });
      } else {
        // 检查是否有可用实例
        this.examineInfoLoading = true;
        this.subclusterDetailDisabled = true;
        postRequest('/api/eda/common/subcluster/runInstances', {
          ...data,
          dryRun: true,
        })
          .then((res) => {
            if (res.errorMessage && res.errorMessage !== '') {
              Message.warning(res.errorMessage);
            } else {
              Message.success(this.$t('customCluster.addInstanceDialog.canCreate'));
            }
            this.examineInfoLoading = false;
            this.subclusterDetailDisabled = false;
          })
          .catch(() => {
            this.examineInfoLoading = false;
            this.subclusterDetailDisabled = false;
          });
      }
    },

    // 订单确认 创建实例
    finishOrder() {
      const data = {
        subclusterId: Number(this.subclusterId),
        instanceCount: Number(this.number),
        startIp: this.startIp,
        password: this.password,
        keepImageLogin: this.isKeepImage,
        terminateActionTime: this.terminateActionTime,
      };

      this.dialogVisible = false;
      this.$message.warning(this.$t('customCluster.addInstanceDialog.creating'));
      this.showLoading && this.showLoading(true);
      // 创建实例
      postRequest('/api/eda/common/subcluster/runInstances', {
        ...data,
        dryRun: false,
      })
        .then(() => {
          this.$notify({
            title: this.$t('common.tip'),
            message: this.$t('customCluster.addInstanceDialog.createSuccess'),
            type: 'success',
            customClass: 'notification-style',
            duration: 0,
          });
          this.showLoading && this.showLoading(false);
          this.getSubclusterInstances && this.getSubclusterInstances();
          this.getSubclusterList && this.getSubclusterList();
        })
        .catch(() => {
          this.showLoading && this.showLoading(false);
        });
    },
    // 获取子集群详情
    getSubclusterDetail() {
      const data = {
        subclusterId: Number(this.subclusterId),
      };
      this.subclusterDetailDisabled = true;
      postRequest('/api/eda/common/subcluster/getSubclusterDetail', data)
        .then((res) => {
          this.info = res.subclusterDetail;
          const list = this.info.subnetCidr.split('/')[0].split('.');
          this.startIp1 = list[0];
          this.startIp2 = list[1];
          this.startIp3 = list[2];
          this.startIp4 = list[3];
          this.subclusterDetailDisabled = false;
          if (res.subclusterDetail.imageType === 'PUBLIC_IMAGE') {
            this.passwordRadio = false;
            this.isKeepImage = false;
          }

          this.unitPriceLoading = true;

          if (this.info.instanceService === 'thpc') {
            getRequest(`https://eda-static-cdn-1300241787.file.myqcloud.com/build/api/public/thpcSellInstanceTypeList.json?t=${new Date().getTime()}`).then((res) => {
              const data = res.find(item => (item.InstanceType === this.info.instanceType && item.InstanceChargeType === this.info.instanceChargeType));
              if (this.info.instanceChargeType === 'POSTPAID_BY_HOUR') {
                this.unitPrice = data?.Price.UnitPrice;
                this.unitPriceDiscount = data?.Price.UnitPriceDiscount;
              } else {
                this.unitPrice = data?.Price.OriginalPrice;
                this.unitPriceDiscount = data?.Price.DiscountPrice;
              }
              this.unitPriceLoading = false;
            });
          } else {
            postRequest('/api/eda/common/tencentcloud/inquiryInstancePrice', res.subclusterDetail).then((res) => {
              this.unitPrice = res.unitPrice;
              this.unitPriceDiscount = res.unitPriceDiscount;
              this.unitPriceLoading = false;
            });
          }

          // PostPaidQuotaSet: 按量计费配额 PrePaidQuotaSet: 包年包月配额 SpotPaidQuotaSet: 竟价配额
          // { value: 'POSTPAID_BY_HOUR', text: '按量计费' },
          // { value: 'PREPAID', text: '包年包月' },
          // { value: 'SPOTPAID', text: '竞价付费' },
          // let quotaType = '';
          // if (res.subclusterDetail.instanceChargeType === 'POSTPAID_BY_HOUR') {
          //   quotaType = 'PostPaidQuotaSet';
          // }
          // if (res.subclusterDetail.instanceChargeType === 'PREPAID') {
          //   quotaType = 'PrePaidQuotaSet';
          // }
          // if (res.subclusterDetail.instanceChargeType === 'SPOTPAID') {
          //   quotaType = 'SpotPaidQuotaSet';
          // }

          // postRequest('/api/eda/common/tencentcloud/describeAccountQuota', {
          //   region: res.subclusterDetail.region,
          //   zone: [res.subclusterDetail.zone],
          //   quotaType: [quotaType],
          // }).then((res) => {
          //   this.describeAccountQuotaInfo = res.overview.AccountQuota[quotaType][0];
          // })
          //   .catch(() => {
          //     this.describeAccountQuotaInfo = {};
          //   });
        })
        .catch(() => {
          this.subclusterDetailDisabled = false;
        });
    },
    validPassword(pwd) {
      if (pwd.length < 12 || pwd.length > 30) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordLengthInvalid'));
        return false;
      }
      if (pwd.includes(' ')) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordContainsSpace'));
        return false;
      }
      if (this.password !== this.nextPassword) {
        Message.warning(this.$t('customCluster.addInstanceDialog.passwordMismatch'));
        return false;
      }

      if (pwd.startsWith('/')) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordStartsWithSlash'));
        return false;
      }

      // 只能含有数字,大小写字母及_@ 其必须包含 一个小写字母 或 一个大写字母 或 数字 或 ()`~!@#$%^&*-+=_|{}[]:;'<>,.?/
      let hasLower = 0;
      let hasUpper = 0;
      let hasDigit = 0;
      let hasSpecial = 0;
      for (let i = 0; i < pwd.length; i++) {
        const char = pwd[i];
        if (char >= 'a' && char <= 'z') {
          hasLower = 1;
        } else if (char >= 'A' && char <= 'Z') {
          hasUpper = 1;
        } else if (char >= '0' && char <= '9') {
          hasDigit = 1;
        } else if ('()`~!@#$%^&*-+=_|{}[]:;\'<>,.?/'.includes(char)) {
          hasSpecial = 1;
        } else {
          this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordInvalid'));
          return false;
        }
      }
      if (hasLower + hasUpper + hasDigit + hasSpecial < 3) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordComplexity'));
        return false;
      }
      return true;
    },
    checkRadio(val) {
      if (val === 1) {
        const list = this.info.subnetCidr.split('/')[0].split('.');
        this.startIp1 = list[0];
        this.startIp2 = list[1];
        this.startIp3 = list[2];
        this.startIp4 = list[3];
      }
    },

    checkPasswordRadio(val) {
      if (val === true) {
        this.isKeepImage = true;
        this.password = '';
        this.nextPassword = '';
      }
      if (val === false) {
        this.password = '';
        this.nextPassword = '';
        this.isKeepImage = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-div > div > span:first-child {
  color: #999;
  width: 74px;
  display: inline-block;
}

.detailInfo_box {
  background: #eee;
  padding: 10px;
  margin-bottom: 20px;
  line-height: 1.8;
  font-size: 12px;
}

.infoTitle {
  width: 70px;
  display: inline-block;
  text-align: left;
}

.numberCls {
  color: #999;
  width: 74px;
  display: inline-block;
}

.hintCls {
  margin-top: -16px;
  color: #999;
  font-size: 10px;
}

.previewDialog_main--div {
  max-height: 500px;
  overflow: auto;
}

.dialog-div {
  div > .el-button {
    padding: 12px;
  }

  .el-input {
    width: 200px;
  }
}

.start-ip__div {
  display: flex;
  align-items: center;

  ::v-deep .el-input__inner {
    text-align: center;
    -moz-appearance: textfield;
  }

  ::v-deep .el-input__inner::-webkit-inner-spin-button,
  ::v-deep .el-input__inner::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
}

.ip-part {
  display: inline-block;

  .el-input {
    width: 40px;
    margin-right: 10px;

    ::v-deep .el-input__inner {
      padding: 0;
    }
  }
}

.notification-style {
  ::v-deep .el-notification {
    width: 200px;
  }
}

.add-btn {
  padding: 0 !important;
  height: 32px;
  margin-left: 10px;
}

.start-ip {
  height: 32px;
  line-height: 32px;
}

.tips {
  p {
    margin-bottom: 10px;
  }
}

.examineMachine {
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.canCreateIP {
  height: 30px;
  line-height: 6px;
}

.formItem__select-short {
  width: 170px;
}

.formItem__select-long {
  width: 500px;
}
</style>
<style>
.tableSelectBac {
  background: #f0f9eb !important;
}
</style>
